import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ContactSection from "../../components/ContactSection";
import HireUs from "../home/sections/HireUs";
import { AboutUI, Title, Paragraph } from "../home/sections/About";
import styled from "styled-components";
import Acordion from "../../components/Acordion";
import { frecuentes } from "../../data/Data";
import WhatsappBTN from "../../components/WhatsappBTN";
const HireUI = styled(AboutUI)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 70px 30px;
`;

const Hire = () => {
  return (
    <>
      <WhatsappBTN />
      <Header />
      <HireUI>
        <HireUs page />
        <Title>
          PREGUNTAS <span>FRECUENTES</span>
        </Title>
        <Paragraph>
          ¿Tenés dudas? Consulta las preguntas más frecuentes que nos hacen.
        </Paragraph>
        <Acordion items={frecuentes} />
      </HireUI>
      <ContactSection />
      <Footer />
    </>
  );
};

export default Hire;
